import { render, staticRenderFns } from "./MyAuthorization.vue?vue&type=template&id=7792bc3f&scoped=true"
import script from "./MyAuthorization.vue?vue&type=script&lang=js"
export * from "./MyAuthorization.vue?vue&type=script&lang=js"
import style0 from "./MyAuthorization.vue?vue&type=style&index=0&id=7792bc3f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7792bc3f",
  null
  
)

export default component.exports